import type { OrgData } from "@p0security/shared/types/tenant/index";

import type { AgenticClientBase } from "./interface.ts";

export const AGENTIC_AUTH_PROVIDER = "agentic";

/** Whether this org's humans sign in with a password, and so deploy the
 * gateway in gcip login mode rather than federating to an upstream provider. */
export const isPasswordLoginOrg = (
  orgData: Pick<OrgData, "auth"> | undefined
) => orgData?.auth?.type === "password";

/** The datastore path at which agentic client docs reside */
export const agenticClientsPath = (tenantId: string) =>
  `o/${tenantId}/features/agentic/clients`;

/** The doc id that holds the client with this identifier
 *
 * A federated client id is a subject with path separators, and this function
 * escapes them. A confidential client id has no separator, and stays the same.
 */
export const agenticClientDocId = (clientId: string) =>
  clientId.includes("/") ? encodeURIComponent(clientId) : clientId;

/** Whether the client cannot authenticate
 *
 * A client with no status is active. All client types must use this function.
 */
export const isAgenticClientDisabled = (
  client: Pick<AgenticClientBase, "status">
) => client.status === "disabled";
